import { Col, Row } from 'antd';
import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Page } from 'components/molecules/page';
import {
  IntegrationHeader,
  PageContent,
} from 'components/organisms/module-settings/integrations/components';

interface IntegrationPageTemplateProps {
  title: string;
  icon?: ReactNode;
  breadcrumbLink?: string;
  breadcrumbText?: string;
  subText?: string;
  learnMoreLink?: string;
  disableBreadcrumb?: boolean;
}

export const IntegrationPageTemplate: FC<IntegrationPageTemplateProps> = ({
  title,
  icon,
  breadcrumbLink,
  breadcrumbText,
  children,
  subText,
  learnMoreLink,
  disableBreadcrumb,
}) => {
  return (
    <Page>
      <IntegrationHeader
        disableBreadcrumb={disableBreadcrumb}
        title={title}
        icon={icon}
        breadcrumbLink={breadcrumbLink}
        breadcrumbText={breadcrumbText}
        subText={subText}
        learnMoreLink={
          learnMoreLink ? (
            <a href={learnMoreLink} target="_blank" rel="noreferrer">
              <FormattedMessage id="learn_more_with_dots" />
            </a>
          ) : null
        }
      />
      <PageContent>
        <Row>
          <Col xl={{ span: 16, offset: 4 }} span={16} offset={4}>
            {children}
          </Col>
        </Row>
      </PageContent>
    </Page>
  );
};
